import template from './campaignMonitorAutoSync.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog, campaignMonitorService, uiService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      ctrl.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller() {
              this.lists = [];
              this.idList = '';
              this.listName = '';
              this.isReady = false;

              campaignMonitorService.lists().then((lists) => {
                this.lists = lists;
                this.isReady = true;
              });

              this.confirm = () => {
                this.isReady = false;
                if (this.idList !== '') {
                  this.listName = _.find(this.lists, (list) => {
                    return list.ListID === this.idList;
                  }).Name;
                  $mdDialog.hide({ id: this.idList, name: this.listName });
                } else {
                  uiService.toast({
                    text: {
                      p1: 'Creating',
                      p2: this.listName,
                      p3: 'campaignMonitor list'
                    },
                    progress: true
                  });
                  campaignMonitorService.listCreate({ name: this.listName }).then((result) => {
                    if (result && result.status) {
                      $mdDialog.hide({ id: result.id, name: result.name });
                    } else {
                      $mdDialog.hide();
                    }
                  });
                }
              };
              this.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      this.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
